
require('../../../node_modules/jquery-youtube-background/src/jquery.youtubebackground.js');

(function() {
    'use strict';

    $('#banner-video').YTPlayer({
        videoId: 'm_YbfS7cGgs'
    });
})(window.groots);
